export default __webpack_public_path__ + "static/media/zeytin-koop.301dba83.png";